import styled from "styled-components";
import Button from "core/Button";
import { convertPxToRem } from "frontend/components/helpers";

export const ButtonsStyled = styled.div`
    margin-bottom: ${convertPxToRem({ px: 24 })};
`;

export const GetAssetButtonStyled = styled(Button)`
    &[aria-disabled="true"]:focus {
        outline: none;
        box-shadow: none;
    }
`;
